module.exports = __webpack_public_path__ + "img/guding.2617be58.svg";